import { useTranslation } from "react-i18next";

import { useBaaComponent } from "../../tenantContent/useBaaComponent";

// Each manufacturer's BAA body lives in its own chunk. Static imports here
// would put every manufacturer's agreement back into the shared — and
// pre-login — bundle, which is the leak this indirection exists to prevent.
// Unknown variants fall back to the platform BAA inside useBaaComponent,
// never to another tenant's body.
function BaaAgreementText({ type = "lucas" }) {
  const { t } = useTranslation();
  const { Component } = useBaaComponent(type);

  if (!Component) return <p className="baa-loading">{t("common.loading", "Loading…")}</p>;
  return <Component />;
}

export default BaaAgreementText;
